import { CardData } from './types';

export const user: CardData = {
  imageSrc: '/assets/avatar/default-avatar.svg',
  name: 'Mehran Bahrami',
  links: [
    { value: '123-456-7890', type: 'PHONE' },
    { value: 'john.doe@example.com', type: 'EMAIL' },
    { value: 'john.doe@example.com', type: 'LINKEDIN' },
    { value: 'john.doe@example.com', type: 'FACEBOOK' },
    { value: 'john.doe@example.com', type: 'TWITTER' },
    { value: 'john.doe@example.com', type: 'INSTAGRAM' },
  ],
  tags: [{ value: 'Owner', type: 'Owner' }],
  status: 'ACTIVE',
};

export const users: CardData[] = [
  {
    imageSrc: '/assets/avatar/default-avatar.svg',
    name: 'Mehran Bahrami',
    links: [
      { value: '123-456-7890', type: 'PHONE' },
      { value: 'john.doe@example.com', type: 'EMAIL' },
      { value: 'john.doe@example.com', type: 'LINKEDIN' },
      { value: 'john.doe@example.com', type: 'FACEBOOK' },
      { value: 'john.doe@example.com', type: 'TWITTER' },
      { value: 'john.doe@example.com', type: 'INSTAGRAM' },
    ],
    tags: [{ value: 'Owner', type: 'Owner' }],
    status: 'ACTIVE',
  },
  {
    imageSrc: '/assets/avatar/default-avatar.svg',
    name: 'Mehran Bahrami',
    links: [
      { value: '123-456-7890', type: 'PHONE' },
      { value: 'john.doe@example.com', type: 'EMAIL' },
      { value: 'john.doe@example.com', type: 'LINKEDIN' },
      { value: 'john.doe@example.com', type: 'FACEBOOK' },
      { value: 'john.doe@example.com', type: 'TWITTER' },
      { value: 'john.doe@example.com', type: 'INSTAGRAM' },
    ],
    tags: [{ value: 'Owner', type: 'Owner' }],
    status: 'DEACTIVATE',
  },
  {
    imageSrc: '/assets/avatar/default-avatar.svg',
    name: 'Mehran Bahrami',
    links: [
      { value: '123-456-7890', type: 'PHONE' },
      { value: 'john.doe@example.com', type: 'EMAIL' },
      { value: 'john.doe@example.com', type: 'LINKEDIN' },
      { value: 'john.doe@example.com', type: 'FACEBOOK' },
      { value: 'john.doe@example.com', type: 'TWITTER' },
      { value: 'john.doe@example.com', type: 'INSTAGRAM' },
    ],
    tags: [{ value: 'Owner', type: 'Owner' }],
    status: 'PENDING',
  },
];
